import { useTranslation } from "react-i18next";
import Modal from "./Modal";
import { useNavigate } from "react-router";

function ModalRequiredDocsReminder({ close }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSetupNow = () => {
    close();
    navigate("/settings/newAccountForm");
  };

  return (
    <Modal close={close} title={t("common.labels.completeRequiredDocuments")} show={true} size="small">
      <div className="dme-reminder-content">
        <div className="reminder-icon mb-20">
          <i className="material-symbols-outlined">description</i>
        </div>

        <p className="mb-20">{t("common.requiredDocs.message")}</p>

        <ul className="reminder-benefits mb-20">
          <li>{t("common.requiredDocs.benefit1")}</li>
          <li>{t("common.requiredDocs.benefit2")}</li>
          <li>{t("common.requiredDocs.benefit3")}</li>
        </ul>
      </div>

      <div className="modal-actions btn-bar">
        <button className="btn btn-secondary" onClick={close}>
          {t("common.dismiss")}
        </button>
        <button className="btn btn-primary" onClick={handleSetupNow}>
          {t("common.requiredDocs.completeNow")}
        </button>
      </div>
    </Modal>
  );
}

export default ModalRequiredDocsReminder;
